import * as React from "react"

import "./img.css";

const Img = ({ imgTitle, url, className, style }) => (
    <img
      alt={imgTitle}
      title={imgTitle}
      style={{ style }}
      className={className}
      src={url}
      data-src={url}
    />
)

export default Img
